import { SET_MODAL_KEEP_WATCHING } from '../actions/modalKeepWatching';

const initialState = {
    comeThisModal: false,
    groupId: "",
    nextGroupId: "",
};

function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_MODAL_KEEP_WATCHING:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/modalKeepWatching.js